<template>
  <div class="list" name="add">
    <el-card style="margin-bottom:20px;padding-bottom:20px" shadow="never">
      <el-col>
        <el-form
                label-position="left"
                style="margin-top: 20px;"
                label-width="130px"
                :model="addForm"
                :rules="rule_data"
                ref="addForm">
          <el-form-item label="登录账号" prop="FAgentAccount">
            <el-input v-model="addForm.FAgentAccount" clear style="width:30%;" placeholder="8-20位数字或字母"></el-input>
            <auth-button
                    opt="check_zone_channel"
                    icon="el-icon-search"
                    class="check"
                    @click.native="checkSubAg"
                    :loading="checkLoading"
                    label="检测"></auth-button>
          </el-form-item>
          <el-form-item label="登录密码" prop="FAgentPassword">
            <el-input v-model="addForm.FAgentPassword" type="password" clear style="width:30%;" placeholder="8-20位大写/小写字母/数字/符号中的至少三种组合"></el-input>
          </el-form-item>
          <el-form-item label="渠道人员姓名" prop="FName">
            <el-input v-model.trim="addForm.FName" clear style="width:30%;"  :onkeyup="addForm.FName = addForm.FName.replace(/\s+/g,'')"></el-input>
          </el-form-item>
          <el-form-item label="渠道人员手机" prop="FMobile" required>
            <el-input v-model="addForm.FMobile" clear style="width:30%;"></el-input>
          </el-form-item>
          <el-form-item label="渠道身份" prop="zzgAgentLevel" v-if="!isInstitution" required>
            <el-select v-model="addForm.zzgAgentLevel" clear placeholder="请选择渠道身份">
                <el-option
                v-for="item in AgentLevelOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item prop="zoneAgentId">
           <el-select v-if='addForm.zzgAgentLevel === 3' v-model="addForm.zoneAgentId" placeholder="请选择归属大区">
                <el-option
                v-for="item in AgentIdOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <!-- <el-form-item v-if='addForm.zzgAgentLevel === 3' label="业务线" prop="professionalFlag" required>
            <el-select v-model="addForm.professionalFlag" clear placeholder="请选择业务线">
                <el-option
                v-for="item in lineBusinessOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </el-form-item> -->
        </el-form>
        <el-button icon="el-icon-circle-plus-outline" @click="addSubmit('addForm')" type="primary" :loading="addLoading">提交</el-button>
      </el-col>
    </el-card>
  </div>
</template>

<script>
import qs from 'qs'
import md5 from 'js-md5'
// export default {AddJs};
import { checkSubAg, addZoneOrChannel, listZone } from '@/api/partner'
import { validStrictPsd, strictPsdError } from '@/utils/validate.js'

export default {
  name: 'AddZoneChannels',
  data () {
    return {
      rule_data: {
        FAgentAccount: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('账号不能空'))
            } else {
              if (/^[a-zA-Z0-9]{8,20}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入正确的账号格式'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FAgentPassword: [{
          validator: (rule, value, callback) => {
            if (validStrictPsd(value)) {
              callback()
            } else {
              return callback(new Error(strictPsdError))
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FName: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入真实姓名'))
            } else {
              if (/^[\u4e00-\u9fa5]{2,6}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入2-6位中文姓名'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FMobile: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入手机号码'))
            } else {
              if (!(/^\d{11,11}$/.test(value))) {
                callback(new Error('请输入11位手机号码'))
              } else {
                callback()
              }
            }
          },
          required: false
        }]
      },
      // 新增界面数据
      addForm: {
        FAgentAccount: '',
        FAgentPassword: '',
        FName: '',
        FMobile: '',
        zzgAgentLevel: '',
        zoneAgentId: ''
        // professionalFlag: ''
      },
      searchInfo: {
        orderState: ''
      },
      checkLoading: false,
      addLoading: false,
      AgentLevelOptions: [{
        value: 2,
        label: '大区经理'
      }, {
        value: 3,
        label: '渠道经理'
      }],
      lineBusinessOptions: [{
        value: 0,
        label: '其它'
      }, {
        value: 1,
        label: '专业市场'
      }],
      AgentIdOptions: []
    }
  },
  methods: {
    // 输入内容去空
    trimLR (val) {
      this[val] = this[val].replace(/\s+/g, '')
    },
    // 检测账号可用性
    checkSubAg () {
      var FAgent = this.addForm.FAgentAccount
      FAgent = { FAgentAccount: FAgent }
      FAgent = qs.stringify(FAgent)
      this.checkLoading = true
      checkSubAg(FAgent).then(data => {
        this.checkLoading = false
        if (parseInt(data.error_code) === 0) {
          this.$message({
            message: data.error_msg,
            type: 'success'
          })
        } else {
          this.$message({
            message: data.error_msg,
            type: 'warning'
          })
        }
      })
    },
    // 新增代理商
    addSubmit (addForm) {
      var that = this
      var pw = this.addForm.FAgentPassword
      this.$confirm('确认提交吗？', '提示', {}).then(() => {
        if (this.addForm.FMobile === '') {
          this.$message({
            type: 'error',
            message: '渠道人员手机不能为空'
          })
          return
        }
        if (this.addForm.zzgAgentLevel === '') {
          this.$message({
            type: 'error',
            message: '渠道身份不能为空'
          })
          return
        }
        if (this.addForm.zzgAgentLevel === 3 && this.addForm.zoneAgentId === '') {
          this.$message({
            type: 'error',
            message: '归属大区不能为空'
          })
          return
        }
        // if (this.addForm.zzgAgentLevel === 3 && this.addForm.professionalFlag === '') {
        //   this.$message({
        //     type: 'error',
        //     message: '业务线不能为空'
        //   })
        //   return
        // }
        this.addLoading = true
        let para = Object.assign({}, this.addForm)
        para = JSON.parse(JSON.stringify(para))
        if (pw) { para.password = md5(pw) }
        para = qs.stringify(para)
        addZoneOrChannel(para).then(data => {
          this.addLoading = false
          if (parseInt(data.error_code) === 0) {
            this.$message({
              message: data.error_msg,
              type: 'success'
            })
            that.$refs.addForm.resetFields()
          } else {
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
            that.$refs.addForm.resetFields()
          }
        }).catch(() => {
          that.$refs.addForm.resetFields()
        })
      })
    },
    // 获取大区列表
    getAgentListZone () {
      listZone().then(res => {
        res.data.forEach(item => {
          this.AgentIdOptions.push({ value: item.frameId, label: item.frameName + ' ' + item.frameId })
        })
      })
    }
  },
  mounted () {
    this.getAgentListZone()
  }
}

</script>
<style rel="stylesheet/scss" lang="scss">
  .demo-form-inline {
    display: inline-block;
    float: right;
  }

  .btm-action {
    margin-top: 20px;
    text-align: center;
  }

  .pagination {
    display: inline-block;
  }
  .list{
    padding-left: 16px;
  }
  .tab-tag{
    height:0;
    padding: 0;
    line-height: 0;
    background: transparent;
  }
  .dsn{
    display: none;
  }
  .check{
    margin-left: 2%;
  }

</style>
